module.exports = __webpack_public_path__ + "img/accessory_item_07.18c1e3c8.svg";